import { useLayoutEffect, useState } from 'react';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import TablePagination from '@mui/material/TablePagination';
import Button from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Table from 'components/Table/Table';

import moment from 'moment';
import LogDetail from './components/LogDetails';

const LogsTable = ({
  classes,
  logs,
  total,
  page,
  perPage,
  setPerPage,
  setPage,
  loading,
  filters,
  setFilters,
  handleSubmitForm,
  sendButton,
  ntAdministration,
  applicationsLocationData,
}) => {
  const [selectedRegister, setSelectedRegister] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableHead, setTableHead] = useState([]);

  const handleToggleModal = () => setOpenModal(!openModal);

  const actionButton = (Icon, color, handler, key, errorEntry) => {
    return (
      <Button
        color={color}
        simple
        className={classes.actionButton}
        onClick={() => handler(key)}
        disabled={errorEntry}
      >
        <Icon className={classes.icon} />
      </Button>
    );
  };

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = async (event) => {
    const rowsPP = parseInt(event.target.value, 10);
    setPerPage(rowsPP);
    setPage(0);
  };

  const handleClickApplication = async (event) => {
    await setPage(0);
    await setFilters((prev) => ({
      ...prev,
      ['activeApplication']: event,
    }));
  };

  const handleViewLog = (key) => {
    setSelectedRegister(key);
    handleToggleModal();
  };

  const getLogsData = () => {
    let logDataTable = logs.map((log, key) => {
      let logData = [];
      let actionButtons = [];

      if (applicationsLocationData.includes(filters.activeApplication)) {
        logData.push(log?.location ?? '');
        logData.push(log?.workstation ?? '');
      }
      logData.push(moment(log?.created_at).format('LLL').toLocaleString());
      logData.push(log?.level);
      let errorEntry =
        log?.message.message instanceof Object ||
        !log?.message?.message ||
        typeof log?.message?.message !== 'string';
      let msg = errorEntry
        ? `ERROR: The entry ID. ${log._id} has some errors in its structure`
        : log?.message.message;
      logData.push(msg);
      actionButtons.push(
        actionButton(
          errorEntry ? VisibilityOff : Visibility,
          'warning',
          handleViewLog,
          key,
          errorEntry
        )
      );
      logData.push(actionButtons);

      return logData;
    });
    setTableData(logDataTable);
  };

  const submittedFilters = filters.applicationTypes;

  useLayoutEffect(() => {
    getLogsData();
  }, [logs]);

  useLayoutEffect(() => {
    if (applicationsLocationData.includes(filters.activeApplication)) {
      setTableHead([
        'Location',
        'Workstation',
        'Date/Time',
        'Log Level',
        'Log',
        'Actions',
      ]);
    } else {
      setTableHead(['Date/Time', 'Log Level', 'Log', 'Actions']);
    }
  }, [filters.activeApplication]);

  return (
    <>
      <>
        {sendButton ? (
          <>
            <Button
              color='info'
              className={
                filters.activeApplication === 'client' ? classes.activeBtn : ''
              }
              disabled={!submittedFilters.includes('client')}
              onClick={() => handleClickApplication('client')}
            >
              MIST Client
            </Button>
            <Button
              color='info'
              className={
                filters.activeApplication === 'server' ? classes.activeBtn : ''
              }
              disabled={!submittedFilters.includes('server')}
              onClick={() => handleClickApplication('server')}
            >
              MIST API Server
            </Button>
            {ntAdministration ? (
              <Button
                color='info'
                className={
                  filters.activeApplication === 'portal'
                    ? classes.activeBtn
                    : ''
                }
                disabled={!submittedFilters.includes('portal')}
                onClick={() => handleClickApplication('portal')}
              >
                Admin Portal
              </Button>
            ) : null}
            <Table tableHead={tableHead} tableData={tableData} />
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component='div'
              count={total}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={perPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
            />
            <LogDetail
              open={openModal}
              handleClose={handleToggleModal}
              data={logs[selectedRegister]}
            />
          </>
        ) : (
          <GridContainer
            direction='column'
            alignItems='center'
            justify='center'
          >
            <GridItem xs={12}>
              <b>No records to display</b>
            </GridItem>
          </GridContainer>
        )}
      </>
    </>
  );
};

export default LogsTable;
